<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3 class="mx-3">Analytics</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3 class="mx-3 overline">Money</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto dark">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                checkingTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Checking Account</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                unitedVisaTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>United Visa</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                chaseFreedomTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Chase Freedom</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                mainSavingsTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Main Savings</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                taxSavingsTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Tax Savings</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                charitySavingsTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Charity Savings</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                schwabOneTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Schwab One</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                gsuTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>GSU</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-row>
      <v-col cols="12">
        <h3 class="mx-3 overline">Activity</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                soulTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Soul Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                coreTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Core Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                backTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Back Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                chestTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Chest Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                armsTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Arms Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                tricepsTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Triceps Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                shouldersTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Shoulders Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                backTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Back Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                legsTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Legs Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{
                mobilityTotal
              }}</v-list-item-title>
              <v-list-item-subtitle>Mobility Reps</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import * as d3 from "d3";

export default {
  name: "Dash",

  data: () => ({}),
  computed: {
    ...mapState({
      sheetsObj: (state) => state.sheet.sheetsObj,
    }),
    checkingTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let checkingTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "chaseChecking") {
              return d.value;
            }
          });
          if (filter.length) {
            checkingTotal = filter[0].value;
          }
        }
        return currency_format(checkingTotal);
      },
    },
    unitedVisaTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let unitedVisaTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "unitedVisa") {
              return d.value;
            }
          });
          if (filter.length) {
            unitedVisaTotal = filter[0].value;
          }
        }
        return currency_format(unitedVisaTotal);
      },
    },
    hiltonAmexTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let hiltonAmexTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "hiltonAmex") {
              return d.value;
            }
          });
          if (filter.length) {
            hiltonAmexTotal = filter[0].value;
          }
        }
        return currency_format(hiltonAmexTotal);
      },
    },
    chaseFreedomTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let chaseFreedomTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "chaseFreedom") {
              return d.value;
            }
          });
          if (filter.length) {
            chaseFreedomTotal = filter[0].value;
          }
        }
        return currency_format(chaseFreedomTotal);
      },
    },
    mainSavingsTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let mainSavingsTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "mainSavings") {
              return d.value;
            }
          });
          if (filter.length) {
            mainSavingsTotal = filter[0].value;
          }
        }
        return currency_format(mainSavingsTotal);
      },
    },
    taxSavingsTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let taxSavingsTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "taxSavings") {
              return d.value;
            }
          });
          if (filter.length) {
            taxSavingsTotal = filter[0].value;
          }
        }
        return currency_format(taxSavingsTotal);
      },
    },
    charitySavingsTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let charitySavingsTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "charitySavings") {
              return d.value;
            }
          });
          if (filter.length) {
            charitySavingsTotal = filter[0].value;
          }
        }
        return currency_format(charitySavingsTotal);
      },
    },
    schwabOneTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let schwabOneTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "schwabOne") {
              return d.value;
            }
          });
          if (filter.length) {
            schwabOneTotal = filter[0].value;
          }
        }
        return currency_format(schwabOneTotal);
      },
    },
    gsuTotal: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let gsuTotal = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "gsu") {
              return d.value;
            }
          });
          if (filter.length) {
            gsuTotal = filter[0].value;
          }
        }
        return currency_format(gsuTotal);
      },
    },
    capitalone360Total: {
      get() {
        // define formats for currency as $19.77 and percent as 52.1%
        const currency_format = d3.format("$,.2f");
        let capitalone360Total = 0;
        const moneyTotals = this.$store.state.sheet.totals.money;
        if (moneyTotals.length) {
          const filter = moneyTotals.filter((d) => {
            if (d.key === "capitalone360") {
              return d.value;
            }
          });
          if (filter.length) {
            capitalone360Total = filter[0].value;
          }
        }
        return currency_format(capitalone360Total);
      },
    },
    soulTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let soulTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "soul") {
              return d.value;
            }
          });
          if (filter.length) {
            soulTotal = filter[0].value;
          }
        }
        return number_format(soulTotal);
      },
    },
    coreTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let coreTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "core") {
              return d.value;
            }
          });
          if (filter.length) {
            coreTotal = filter[0].value;
          }
        }
        return number_format(coreTotal);
      },
    },
    backTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let backTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "back") {
              return d.value;
            }
          });
          if (filter.length) {
            backTotal = filter[0].value;
          }
        }
        return number_format(backTotal);
      },
    },
    chestTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let chestTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "chest") {
              return d.value;
            }
          });
          if (filter.length) {
            chestTotal = filter[0].value;
          }
        }
        return number_format(chestTotal);
      },
    },
    legsTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let legsTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "legs") {
              return d.value;
            }
          });
          if (filter.length) {
            legsTotal = filter[0].value;
          }
        }
        return number_format(legsTotal);
      },
    },
    tricepsTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let tricepsTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "triceps") {
              return d.value;
            }
          });
          if (filter.length) {
            tricepsTotal = filter[0].value;
          }
        }
        return number_format(tricepsTotal);
      },
    },
    armsTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let armsTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "arms") {
              return d.value;
            }
          });
          if (filter.length) {
            armsTotal = filter[0].value;
          }
        }
        return number_format(armsTotal);
      },
    },
    shouldersTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let shouldersTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "shoulders") {
              return d.value;
            }
          });
          if (filter.length) {
            shouldersTotal = filter[0].value;
          }
        }
        return number_format(shouldersTotal);
      },
    },
    bodyTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let bodyTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "body") {
              return d.value;
            }
          });
          if (filter.length) {
            bodyTotal = filter[0].value;
          }
        }
        return number_format(bodyTotal);
      },
    },
    mobilityTotal: {
      get() {
        // define formats for numbers with commas
        const number_format = d3.format(",");
        let mobilityTotal = 0;
        const activityTotals = this.$store.state.sheet.totals.activity
          .muscleGroup;
        if (activityTotals.length) {
          const filter = activityTotals.filter((d) => {
            if (d.key === "mobility") {
              return d.value;
            }
          });
          if (filter.length) {
            mobilityTotal = filter[0].value;
          }
        }
        return number_format(mobilityTotal);
      },
    },
  },
  methods: {
    async calculateTotals() {
      // rando totals
      const moneyTotals = d3
        .nest()
        .key((d) => d.source)
        .rollup((v) => d3.sum(v, (d) => d.amount))
        .entries(this.sheetsObj.money.data);

      const exerciseTotals = d3
        .nest()
        .key((d) => d.exercise)
        .rollup((v) => d3.sum(v, (d) => d.reps))
        .entries(this.sheetsObj.activity.data);

      const muscleGroupTotals = d3
        .nest()
        .key((d) => d.muscleGroup)
        .rollup((v) => d3.sum(v, (d) => d.reps))
        .entries(this.sheetsObj.activity.data);

      this.$store.dispatch("sheet/updateSheetsState", {
        state: "totals",
        field: "money",
        value: moneyTotals,
      });
      this.$store.dispatch("sheet/updateSheetsState", {
        state: "totals",
        field: "activity",
        subfield: "exercise",
        value: exerciseTotals,
      });
      this.$store.dispatch("sheet/updateSheetsState", {
        state: "totals",
        field: "activity",
        subfield: "muscleGroup",
        value: muscleGroupTotals,
      });
    },
  },
  mounted() {
    this.calculateTotals();
  },
};
</script>
